export function useRedirects() {
	const config = useAppConfig();
	const nuxtApp = useNuxtApp();

	async function fetchRedirects() {
		const redirects = await useApi(`/api/nuxtapi/redirects/`);
		nuxtApp.$appData.redirects = redirects || null;
		return redirects;
	}

	function findRedirect(redirects, currentPath) {
		if (!redirects) return false;

		const pathOnly = currentPath.split('?')[0];
		const staticSet = new Set(redirects.s || []);
		if (staticSet.has(currentPath) || staticSet.has(pathOnly)) {
			return true;
		}

		const regexList = redirects.r || [];
		for (let i = 0; i < regexList.length; i++) {
			let pattern = regexList[i];

			try {
				const cleanPattern = pattern
					.replace(/\//g, '\\/') // Escape kosih crta
					.replace(/\(slug\+\)/g, '[a-zA-Z0-9_+-]+') // Slug (tekst)
					.replace(/\(id\+\)/g, '\\d+') // ID (brojevi)
					.replace(/\(\.\*\)/g, '.*') // Bilo što (zero or more)
					.replace(/\(\.\+\)/g, '.+') // Bilo što (one or more)
					.replace(/\*/g, '.*'); // Standardni wildcard u regex

				const regex = new RegExp('^' + cleanPattern + '\\/?(?:\\?.*)?$', 'i');

				if (regex.test(currentPath)) {
					return true;
				}
			} catch (e) {
				console.warn('Greška u obradi regexa:', pattern);
			}
		}

		return false;
	}

	async function fetchRedirect(redirectUrl) {
		// Sanitize input: must be a relative path, not oversized, not recursive
		if (typeof redirectUrl !== 'string' || redirectUrl.length > 500 || !redirectUrl.startsWith('/') || redirectUrl.startsWith('//') || (redirectUrl.match(/[?&]url=/gi) || []).length > 1) {
			return;
		}

		const redirect = await useApi(`/${config.api}/${config.apiVersion}/cms/redirect/?url=${redirectUrl}`);
		try {
			if (redirect?.data?.redirect_url_without_domain) {
				return redirect.data;
			}
		} catch (e) {
			console.error('Error fetching redirect:', e);
		}
	}

	function getRedirects() {
		return nuxtApp?.$appData?.redirects || null;
	}

	return {fetchRedirects, fetchRedirect, findRedirect, getRedirects};
}
